import { useDeleteIdentityProof } from '@commenda/api';
import { useNotification } from '../../../hooks/useNotification';
import { DeleteConfirmationModal } from '../../../molecules/modals/ConfirmationModal';

export const RemoveProofModal = ({
  isOpen,
  onClose,
  keyPersonId,
  assignmentId,
  proofLabel,
}: {
  isOpen: boolean;
  onClose: () => void;
  keyPersonId: number;
  assignmentId: string | null;
  proofLabel?: string;
}) => {
  const { setNotification } = useNotification();
  const { mutateAsync: removeProof } = useDeleteIdentityProof(keyPersonId);

  const handleConfirm = async () => {
    if (!assignmentId) return;
    try {
      await removeProof(assignmentId);
      setNotification({
        show: true,
        title: 'Proof removed',
        message: 'The proof of identity has been removed.',
        valid: true,
      });
    } catch (error) {
      setNotification({
        show: true,
        title: 'Failed to remove proof',
        message: error instanceof Error ? error.message : 'Please try again.',
        valid: false,
      });
      // Re-throw so the modal stays open on failure (it auto-closes on a resolved confirm).
      throw error;
    }
  };

  return (
    <DeleteConfirmationModal
      isOpen={isOpen}
      onClose={onClose}
      onConfirm={handleConfirm}
      title="Remove proof of identity?"
      message={`This clears the saved details for the ${proofLabel ?? 'selected'} proof of identity — its document number and any uploaded file. This action cannot be undone.`}
      confirmButtonText="Remove"
    />
  );
};
